import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { SwitchThemeService } from '../../../../shared/components/switch-theme/switch-theme.service';
import { DistributionSlice } from '../../core/models/dashboard.model';
import { TimeEntryMetricsModel } from '../../core/models/time-entry-metrics.model';
import { TimeEntryMetricsComponent } from '../time-entry-metrics/time-entry-metrics.component';

/**
 * Diálogo que hospeda a grade de métricas de apontamentos. Só embrulha — o
 * modelo vem pronto de fora e as fatias clicáveis sobem para a tela hospedeira
 * como `sliceActivate`.
 *
 * Mesma receita de tema do `time-entry-history-modal`: a tela hospedeira é
 * legada, não tem o wrapper `.tw-light-theme`, e o `p-dialog` sai do lugar onde
 * foi declarado — sem os defaults de `--v-*` no SCSS e a classe de tema no
 * `styleClass`, a grade abre sem cor nenhuma.
 */
@Component({
  selector: 'app-time-entry-metrics-modal',
  standalone: true,
  imports: [DialogModule, ButtonModule, TimeEntryMetricsComponent],
  templateUrl: './time-entry-metrics-modal.component.html',
  styleUrls: ['./time-entry-metrics-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class TimeEntryMetricsModalComponent {
  private readonly switchThemeService = inject(SwitchThemeService);

  private readonly currentTheme = toSignal(this.switchThemeService.currentTheme, {
    initialValue: this.switchThemeService.currentTheme.value,
  });

  @Input({ required: true }) model!: TimeEntryMetricsModel;
  @Input() visible = false;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() sliceActivate = new EventEmitter<DistributionSlice>();

  onHide(): void {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  getDialogStyleClass(): string {
    const themeClass = this.currentTheme() === 'dark' ? 'tw-dark-theme' : 'tw-light-theme';
    return `time-entry-metrics-dialog ${themeClass}`;
  }
}
